import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initSentry } from '@/lib/sentry'
import { initPostHog } from '@/lib/posthog'
import { consumeImpersonationCodeFromUrl } from '@/lib/impersonation'
import { isStaleChunkError, reloadOnceForStaleChunk } from '@/lib/lazyWithReload'
import { consumeAppleWebSigninPayloadFromUrl } from '@/lib/appleWebSignin'
import { consumeDesktopShellMarkerFromUrl } from '@/lib/desktopShell'

// Stale-chunk safety nets that fire outside React's render path (BEO-2381):
// Vite's preload-error event for failed modulepreload links, and any
// dynamic-import rejection that escaped lazyWithReload as an unhandled promise.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  reloadOnceForStaleChunk()
})

window.addEventListener('unhandledrejection', (event) => {
  if (!isStaleChunkError(event.reason)) return
  event.preventDefault()
  reloadOnceForStaleChunk()
})

// Strip any impersonation code from the URL fragment BEFORE analytics init, so
// the one-time code can't be captured in the initial PostHog pageview.
consumeImpersonationCodeFromUrl()
consumeAppleWebSigninPayloadFromUrl()
consumeDesktopShellMarkerFromUrl()

initSentry()
initPostHog()
const root = createRoot(document.getElementById('root')!)
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)
